// extracted by mini-css-extract-plugin
module.exports = {"button":"icon-link-button_button__iFJ22"};